import type { FaireProductEntity } from "../../entity_types/product";

export const matcha_6: FaireProductEntity = {
  token: "matcha-6",
  type: "product",
  name: "Organic Ceremonial Matcha",
  brandName: "Oddly specific",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/e0579fcee4a808449cb5415336e74e56b846ca824c48d4e19eca4bbdef031324.png",
  priceDollars: 3,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/e0579fcee4a808449cb5415336e74e56b846ca824c48d4e19eca4bbdef031324.png",
  weight: 0.2,
  dimensions: {
    width: 3,
    height: 5,
    depth: 2,
  },
  description: "Organic ceremonial grade matcha",
  categoryTokens: ["cat_food-beverages"],
  tags: [
    "matcha",
    "tea",
    "japanese-green-tea",
    "ceremonial",
    "organic",
    "premium",
  ],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
